"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveTemplateString = void 0;
const lodash_1 = require("lodash");
const assert_1 = __importDefault(require("assert"));
/**
 * Replaces placeholders "${ctx.attr.value}" with context values
 */
function resolveTemplateString(tpl, ctx) {
    return tpl.replace(/(\${([^}]+)})/g, (_, __, path) => {
        const resolved = lodash_1.get(ctx, path);
        assert_1.default(resolved, `failed to resolve ${path}`);
        return resolved;
    });
}
exports.resolveTemplateString = resolveTemplateString;
//# sourceMappingURL=resolveTemplateString.js.map